import React from "react";

export default function AppFilterChip({
  size = "md",
  selected = false,
  count = null,
  className = "",
  children,
  type = "button",
  ...props
}) {
  const classes = ["ds-filter-chip", `ds-filter-chip--${size}`, selected ? "is-selected" : "", className]
    .filter(Boolean)
    .join(" ");

  return (
    <button type={type} className={classes} aria-pressed={selected} {...props}>
      <span className="ds-filter-chip__label">{children}</span>
      {count != null ? <span className="ds-filter-chip__count">{count}</span> : null}
    </button>
  );
}
